import { Box, Typography } from '@mui/material'

import { StyledTooltip } from '@/shared/components/StyledTooltip'

import type { BedarfVerbrauchLabelProps } from './BedarfVerbrauchLabel.types'
import { BedarfVerbrauchType } from './BedarfVerbrauchLabel.types'

export const BedarfVerbrauchLabel = ({ type }: BedarfVerbrauchLabelProps) => {
  const bedarfContent = (
    <Box
      component="span"
      sx={{
        color: type === BedarfVerbrauchType.BEDARF ? '#6B9070' : '#A3A5A9',
        ...(type === BedarfVerbrauchType.BEDARF && {
          backgroundColor: '#E5F5E7',
          borderRadius: '2px',
          paddingX: '4px',
          paddingY: '2px',
        }),
        cursor: type === BedarfVerbrauchType.BEDARF ? 'pointer' : 'text',
      }}
    >
      Bedarf
    </Box>
  )

  const verbrauchContent = (
    <Box
      component="span"
      sx={{
        color: type === BedarfVerbrauchType.VERBRAUCH ? '#6B9070' : '#A3A5A9',
        ...(type === BedarfVerbrauchType.VERBRAUCH && {
          backgroundColor: '#E5F5E7',
          borderRadius: '2px',
          paddingX: '4px',
          paddingY: '2px',
        }),
        cursor: type === BedarfVerbrauchType.VERBRAUCH ? 'pointer' : 'text',
      }}
    >
      Verbrauch
    </Box>
  )

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography
        component="span"
        sx={{
          fontWeight: 400,
          fontSize: '10px',
          lineHeight: '14px',
        }}
      >
        {type === BedarfVerbrauchType.BEDARF ? (
          <StyledTooltip title="Die Energieklasse wird bedarfsbasiert nach GEG gemäß DIN 18599 berechnet.">
            {bedarfContent}
          </StyledTooltip>
        ) : (
          bedarfContent
        )}
        <Box component="span" sx={{ color: '#464A54' }}>
          {' / '}
        </Box>
        {type === BedarfVerbrauchType.VERBRAUCH ? (
          <StyledTooltip title="Das Einsparpotenzial wird auf Grundlage des Energieverbrauchs berechnet, um eine realitätsnähere Einschätzung zu liefern.">
            {verbrauchContent}
          </StyledTooltip>
        ) : (
          verbrauchContent
        )}
      </Typography>
    </Box>
  )
}
